import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const Chemistry = () => {
  const homeMenu = [
    {
      label: "Curriculum",
      link: "",
      subMenu: [
        { label: "Primary Wing", link: "/primarywing" },
        { label: "Middle Wing", link: "/middleWing" },
        { label: "Senior Wing", link: "/seniorWing" },
        { label: "Curriculum", link: "/curriculum" },
      ],
    },

    {
      label: "Extended Classroom",
      link: "",
      subMenu: [
        { label: "Labs", link: "/mathmatics" },
        { label: "Excursions", link: "/excursions" },
        { label: "Library", link: "/library" },
        { label: "Field Trips", link: "/feildTrip" },
        { label: "Astronomy", link: "/astronomy" },
      ],
    },
    {
      label: "Sports",
      link: "",
      subMenu: [
        { label: "Sports", link: "/sports" },
        {
          label: "Achievements in Sports 2022-23",
          link: "/acheivementInSports",
        },
      ],
    },
    {
      label: "Arts",
      link: "",
      subMenu: [
        { label: "Performing Arts", link: "/music" },
        { label: "Visual Arts", link: "/visualArts" },
      ],
    },

    { label: "Houses", link: "/houses" },
    { label: "Assembly", link: "/assembly" },
    { label: "Book List", link: "/booklist" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/learning-app.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Facilities"
                breadEnd="Learning Approach"
                breadMid="Chemistry Lab"
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-xl-12 mb-4">
              <h4 className="color-red">Chemistry</h4>
              <div class="lab-heading mb-4">
                <div class="lab-btn" id="mb-lab-btn">
                  <span>Labs</span>
                </div>
                <ul class="labs-list">
                  <li>
                    <a class="" href="/mathmatics">
                      Mathematics
                    </a>
                  </li>
                  <li>
                    <a class="" href="/physics">
                      Physics
                    </a>
                  </li>
                  <li>
                    <a class="" href="/biology">
                      Biology
                    </a>
                  </li>
                  <li>
                    <a class="inc-tlink-active" href="/chemistry">
                      Chemistry
                    </a>
                  </li>
                  <li>
                    <a class="" href="/language">
                      Language
                    </a>
                  </li>
                  <li>
                    <a class="" href="/computer">
                      Computer
                    </a>
                  </li>
                  <li>
                    <a class="" href="/robotics">
                      Robotics
                    </a>
                  </li>
                  <li>
                    <a class="" href="/hands-on-studio">
                      Hands On Studio
                    </a>
                  </li>
                  <li>
                    <a class="" href="/psychology">
                      Psychology
                    </a>
                  </li>
                  <li>
                    <a class="" href="/counseling-sen">
                      Counseling &amp; Sen{" "}
                    </a>
                  </li>
                </ul>
              </div>
              <p>
                <i>
                  “We must trust to nothing but facts: These are presented to us
                  by Nature, and cannot deceive. We ought, in every instance, to
                  submit our reasoning to the test of experiment, and never to
                  search for truth but by the natural road of experiment and
                  observation.” Antoine Lavoisier, Elements of Chemistry
                </i>
              </p>
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/science-lab1.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                We at <b>Lotus Valley International School, Gurgaon</b> provides
                controlled conditions in which scientific or technological
                research, experiments, and measurement may be performed.
              </p>
              <p>
                Laboratory equipment is generally used to either perform an
                experiment or to take measurements and gather data. Larger or
                more sophisticated equipment is generally called a scientific
                instrument. Both laboratory equipment and scientific instruments
                are increasingly being designed and shared using open hardware
                principle
              </p>

              <p>LVIS Chemistry laboratory equipments</p>
              <ul className="admission-list">
                <li>
                  laboratory glassware such as the beaker or reagent bottle
                </li>
                <li>Analytical devices as HPLC or spectrophotometers</li>
                <li>
                  Titration devices such as burette , pipette, volumetric flask
                </li>
                <li>Salt analysis device such as kripp’s apparatus</li>
              </ul>
              <p>
                <b>Safety</b>
              </p>
              <p>
                In laboratories, the conditions are no more dangerous than in
                any other room, though, hazards are present. Laboratory hazards
                are as varied as the subjects of study in laboratories, and
                might include flammable or
                explosivematerials;extremetemperatures; where dangerous
                conditions might exist, safety precautions are important.
              </p>
              <p>
                To minimize the individual's risk, and safety equipment is used
                to protect the lab user from injury or to assist in responding
                to an emergency.
              </p>
              <p>
                Lotus valley’s chemistry laboratory is well ventilaled, having
                fire alarm, two entry / exit gate as well as. Our lab is capable
                of accommodating 30-35 learners.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Chemistry;
